import { render, staticRenderFns } from "./BuyerReturnFilters.vue?vue&type=template&id=05724da1&"
import script from "./BuyerReturnFilters.vue?vue&type=script&lang=js&"
export * from "./BuyerReturnFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports